// extracted by mini-css-extract-plugin
export default {"root":"Carousel-module-root-T1Wvc","horizontal":"Carousel-module-horizontal-eQTd2","list":"Carousel-module-list-LXWP3","rtl":"Carousel-module-rtl-SY6nE"};